var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_c('div',{staticClass:"title"},[(_vm.type === 0)?[_c('Administrator')]:[_c('DomesticConsumer')]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }